import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { readCookie, writeCookie } from '@/tools/tools';
import { getUserInfo } from '@/services/http';
/**
 * getters
 */
// export const getters: GetterTree<UserState, RootState> = {
//   addresslist: (state: UserState) => state.userinfolist,
// };
/**
 * mutations
 */
export var mutations = {
  // 收货列表
  USERINFORLIST: function USERINFORLIST(state, payload) {
    state.userinfolist = payload;
    writeCookie('userinfolist', state.userinfolist);
  }
};
/**
 * actions
 */
export var actions = {
  setUserInfoList: function setUserInfoList(_ref) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var commit, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            _context.next = 3;
            return getUserInfo({
              companyId: 1
            });
          case 3:
            res = _context.sent;
            commit('USERINFORLIST', res.data.data);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};
/**
 * state
 */
export var state = {
  userinfolist: readCookie('userinfolist') ? readCookie('userinfolist') : []
};
var namespaced = true;
export var user = {
  namespaced: namespaced,
  state: state,
  mutations: mutations,
  actions: actions
};